import React from 'react';

const ToggleBar = ({ styles, active, onToggle, label }) => (
  <button
    type="button"
    className={`${styles.toggleBtn} ${active ? styles.toggleBtnActive : ""}`} 
    onClick={onToggle}
  >
    <span>{label}</span> 
    <span className={styles.toggleIcon}>{active ? "-" : "+"}</span>
  </button>
);

const ResearchHero = ({ styles, openRag, openTune, openConsult, onToggleRag, onToggleTune, onToggleConsult, }) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.heroCenter}>
          <h1 className={styles.h1}>Research & Development</h1>

          <p className={styles.heroLead}>
            <b>AI 기술을 “업무 성과”로 연결하는 연구</b>
          </p>

          <p className={styles.heroText}>
            메타에이아이는 문서·지식·데이터 기반의 AI 시스템을 연구하고, 산업 특성에 맞는 모델/알고리즘 전략을 설계하여
            실제 비즈니스에서 <b>정확성·효율·ROI</b>를 높이는 방향으로 적용합니다.
          </p>

          <div className={styles.heroTags}>
            <span className={styles.tag}>RAG</span>
            <span className={styles.tag}>Fine-tuning</span>
            <span className={styles.tag}>Algorithm Strategy</span>
            <span className={styles.tag}>PoC · ROI</span>
          </div>

          <div className={styles.heroCtaRow}>
            <ToggleBar styles={styles} label="RAG 시스템" active={openRag} onToggle={onToggleRag} />
            <ToggleBar styles={styles} label="Custom Fine-Tuning" active={openTune} onToggle={onToggleTune} />
            <ToggleBar styles={styles} label="AI 컨설팅/전략" active={openConsult} onToggle={onToggleConsult} />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ResearchHero